/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */

const files = require.context('./modules', false, /\.js$/)
const filesComponents = require.context('./modules/components', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
filesComponents.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = filesComponents(key).default
})



export default {
  namespaced: true,
  modules
}
